import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import SettingsListBody from "components/PatientManagement/Settings/SettingsListBody";

export default function Settings() {
  useEffect(() => {
    document.title = "Settings";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="patientmanagement" />
      <SettingsListBody />
    </main>
  );
}
